module.exports = __webpack_public_path__ + "static/media/SeeingSound_10.ae790d99.JPG";